import type { GameItemType } from '@/types'

// Papéis de item do catálogo da mesa (espelha ITEM_TYPES do backend).
export const ITEM_TYPES: {
  value: GameItemType
  label: string
  description: string
}[] = [
  { value: 'trofeu', label: 'Troféu', description: 'Artefato colecionável, marca uma conquista' },
  { value: 'chave', label: 'Chave', description: 'Item de enredo que libera algo na aventura' },
  { value: 'consumivel', label: 'Consumível', description: 'Item que se gasta ao ser usado' },
  { value: 'equipamento', label: 'Equipamento', description: 'Item que o personagem carrega/veste' },
]

export function itemTypeLabel(type: string): string {
  return ITEM_TYPES.find((t) => t.value === type)?.label ?? type
}
